import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { performContactUs } from '../contactUsDuck'
import formValidators from '../../../../utils/validation/formValidators'
import selectors from '../../../../store/shared/selectors'
import renderTextInputWithFeedback from '../../../../components/ui/forms/renderTextInputWithFeedback'
import renderTextAreaInputWithFeedback from '../../../../components/ui/forms/renderTextAreaInputWithFeedback'
import notificationsUtils from '../../../../utils/notifications/notificationsUtils'
import fullstory from '../../../../utils/constants/fullstory'

class PostEditForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    isSendingRequest: PropTypes.bool.isRequired,
  }

  render() {
    const { handleSubmit, isSendingRequest } = this.props

    return (
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-12">
            <Field
              className={fullstory.classNames.textInput}
              component={renderTextInputWithFeedback}
              label="Subject"
              name="subject"
              type="text"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <Field
              component={renderTextAreaInputWithFeedback}
              label="How can we help you?"
              maxLength={1000}
              name="body"
              rows={10}
              type="text"
            />
          </div>
        </div>
        <div className="row justify-content-md-center">
          <div className="col-md-6">
            <button type="submit" className="btn btn-block btn-success" disabled={isSendingRequest}>
              {isSendingRequest ? <i className="fal fa-spinner" /> : 'Contact Us'}
            </button>
          </div>
        </div>
      </form>
    )
  }
}

/**
 * @const validate
 * @desc Checks whether our form is valid
 * @param values
 * @returns {{}}
 */
const validate = values => {
  const errors = {}
  errors.subject = formValidators.isRequired(values.subject)
  errors.body = formValidators.isRequired(values.body)
  return errors
}

/**
 * @const wrappedWithForm
 * @desc Gives ContactUsForm extra props like invalid, pristine, and handleSubmit
 */
const wrappedWithForm = reduxForm({
  destroyOnUnmount: true,
  form: 'contactUsForm',
  onSubmit: async (values, _dispatch, props) => {
    try {
      await props.performContactUs({
        ...values,
        name: props.user && props.user.profile.name,
        email: props.user && props.user.email,
      })
      notificationsUtils.showSuccessNotification('Support request sent successfully!')
    } catch (error) {
      notificationsUtils.showErrorNotification(
        'Error in sending support request, please try again.',
      )
    }
  },
  validate,
})(PostEditForm)

/**
 * @const makeMapStateToProps
 * @param state
 */
const makeMapStateToProps = () => {
  const isPerformingRequest = selectors.makeGetIsPerformingRequest()
  return state => ({
    isSendingRequest: isPerformingRequest(state, 'contactUs'),
    user: selectors.getCurrentUser(state),
  })
}

/**
 * @const mapDispatchToProps
 * @desc Binds an Action Performer to this.props
 * @param dispatch
 */
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      performContactUs,
    },
    dispatch,
  )

export default connect(makeMapStateToProps, mapDispatchToProps)(withRouter(wrappedWithForm))



// WEBPACK FOOTER //
// ./src/routes/authenticated/UserProfile/components/ContactUsForm.js